module.exports = __webpack_public_path__ + "static/media/icon_info.529f9e32.svg";